import React, { useRef, useState } from "react";
import "./Contact.css";
import { BsLinkedin, BsGithub, BsMedium } from "react-icons/bs";
import useInView from "../hooks/useInView";

function Contact() {
	const [myRef, visible] = useInView();
	const [isSubmitted, setIsSubmitted] = useState(false);
	const [sendingData, setSendingData] = useState(false);
	const [error, setError] = useState("");
	const [formData, setFormData] = useState({
		name: "",
		email: "",
		subject: "",
		message: "",
	});
	// Spam signals checked by the Apps Script: a hidden field only bots fill in,
	// and how long the form was open before submitting.
	const [website, setWebsite] = useState("");
	const formLoadedAt = useRef(Date.now());

	const handleSubmit = async (e) => {
		e.preventDefault();
		setError("");
		try {
			setSendingData(true);
			const sendMessageData = await fetch(
				"https://script.google.com/macros/s/AKfycbyS-R0S8JSSQYNuo-39BcwJN3ejuQ5UKBxj5Xwn2c3-iBsXsCeZ-MdVSWZm55HkivOP/exec",
				{
					redirect: "follow",
					method: "POST",
					headers: {
						"Content-Type": "text/plain;charset=utf-8",
					},
					body: JSON.stringify({
						name: formData.name,
						email: formData.email,
						subject: formData.subject,
						message: formData.message,
						website,
						elapsedMs: Date.now() - formLoadedAt.current,
					}),
				},
			);

			await sendMessageData.json();
			setIsSubmitted(true);
		} catch (err) {
			setError(
				"Something went wrong. Please try again or reach out directly via LinkedIn.",
			);
			console.error("Error calling Apps Script:", err);
		} finally {
			setSendingData(false);
		}
	};

	return (
		<div className="contact" id="contact">
			<div className="shimmer contact_background_wrapper">contact</div>
			<div
				ref={myRef}
				className={`${visible ? "contact_reveal" : "contact_reveal_inactive"}`}
			>
				<div className="contact_filler"></div>
				<div className="root_contact_container">
					<div className="contact_container">
						<div className="contact_wrapper">
							{!isSubmitted ? (
								<form
									id="form"
									className="form_container"
									autoComplete="off"
									onSubmit={handleSubmit}
								>
									<div className="contact_first_line">
										<div className="name_wrapper">
											<input
												type="text"
												id="Name"
												name="Name"
												className="input_name"
												placeholder="Name"
												value={formData.name}
												onChange={(e) =>
													setFormData({ ...formData, name: e.target.value })
												}
												required
											/>
										</div>
										<div className="email_wrapper">
											<input
												type="email"
												id="Email"
												name="Email"
												className="input_email"
												placeholder="Email"
												value={formData.email}
												onChange={(e) =>
													setFormData({ ...formData, email: e.target.value })
												}
												required
											/>
										</div>
									</div>
									<div className="contact_second_line">
										<div className="subject_wrapper">
											<input
												type="text"
												id="Subject"
												name="Subject"
												className="input_subject"
												placeholder="Subject"
												value={formData.subject}
												onChange={(e) =>
													setFormData({ ...formData, subject: e.target.value })
												}
												required
											/>
										</div>
									</div>
									<div className="contact_third_line">
										<div className="message_wrapper">
											<textarea
												id="Message"
												name="Message"
												className="input_message"
												placeholder="Message"
												value={formData.message}
												onChange={(e) =>
													setFormData({ ...formData, message: e.target.value })
												}
												required
											></textarea>
										</div>
									</div>
									<div className="contact_hp" aria-hidden="true">
										<input
											type="text"
											name="website"
											tabIndex={-1}
											autoComplete="off"
											value={website}
											onChange={(e) => setWebsite(e.target.value)}
										/>
									</div>
									<div className="contact_submit_line">
										<div className="submit_wrapper">
											<button
												type="submit"
												value="Submit"
												className="input_submit"
												disabled={sendingData}
											>
												{sendingData ? "Sending..." : "Submit"}
											</button>
										</div>
									</div>
									{error && (
										<div className="error_message">
											<p>{error}</p>
										</div>
									)}
								</form>
							) : (
								<div className="success_message">
									<h2>Submission Successful</h2>
									<p>
										Thank you for reaching out! I'll get back to you as soon as
										possible.
									</p>
								</div>
							)}
						</div>
					</div>
				</div>
				<div className="icon-links">
					<div className="icon-links_container">
						<a
							className="linked-in_wrapper"
							href="https://www.linkedin.com/in/wyatt-chamberlin-ab3b14100/"
							target="_blank"
							rel="noopener noreferrer"
							aria-label="LinkedIn"
						>
							<BsLinkedin className="linked-in" />
						</a>
						<a
							className="github_wrapper"
							href="https://github.com/elkaholic6"
							target="_blank"
							rel="noopener noreferrer"
							aria-label="GitHub"
						>
							<BsGithub className="github" />
						</a>
						<a
							className="medium_wrapper"
							href="https://medium.com/@wyattchamberlin6"
							target="_blank"
							rel="noopener noreferrer"
							aria-label="Medium"
						>
							<BsMedium className="medium" />
						</a>
					</div>
				</div>
			</div>
		</div>
	);
}

export default Contact;
